export const Channel: { [index: number]: string } = {
  0: 'PAPER',
  1: 'MAIL',
  3: 'FILEACQUIRE',
  4: 'DISK',
  5: 'SPLITTER',
  6: 'EINVOICE',
  7: 'VENDOR_PORTAL',
  8: 'AP_15',
};

export const Priority = {
  0: 'NORMAL',
  1: 'MEDIUM',
  2: 'HIGH',
};

export enum ErrorTypes {
  MAILNOTDECODED = -1,
  PROTOCOLERROR = -2,
  ATTACHRASTERERROR = -3,
  MAILNOTDECODED_UNKNOWNSTATE = -4,
  MAILNOTRECOVERED = -5,
  MAILNOATTACH = -6,
  MAILUNAUTHORIZEDSENDER = -7,
  MAILUNKNOWNDOCTYPE = -8,
  PROTECTIONERROR = -10,
  ARCHIVEERROR = -11,
  DIMENSIONERROR = -12,
  TIFFERROR = -13,
  WEIGHTERROR = -14,
  PAGESERROR = -15,
  SUPPLIERERROR = -16,
  DISPATCHQUEUEERROR = -18,
  UNKNOWNDOCFORMAT = -19,
  MAILDUPLICATEDMSGID = -20,
  DUPLICATE = -21,
  FORCED_BY_MAPPER = -22,
  GENERICERROR = -80,
}

export enum LoginBlocked {
  PASSWORD_ERROR = 0,
  GENERAL_BLOCKED,
  JDBC_BLOCKED,
  DUE_DATE_BLOCKED,
  MAX_LOGIN_BLOCKED,
  IP_BLOCKED,
  CHANGE_PASSWORD,
  TEMPORARY_PASSWORD_EXPIRED,
}
